import { computed } from 'vue';

import { useCaseStore } from '@/stores/case';
import { useProductMatrixStore } from '@/stores/product-matrix';
import { CaseStatus, CaseType } from '@onrunning/backstage-models';

export function useCaseValidation() {
  const caseStore = useCaseStore();
  const productMatrixStore = useProductMatrixStore();

  const caseOrder = computed(() => {
    return caseStore.updatedCaseOrder ?? caseStore.caseOrder;
  });

  const isNewCase = computed(() => !caseOrder.value?.caseNumber);
  const isReturn = computed(() => caseOrder.value?.type === CaseType.Return);
  const isWarranty = computed(() => caseOrder.value?.type === CaseType.Warranty);
  const caseNotSubmitted = computed(() => caseOrder.value?.status === CaseStatus.NotSubmitted);

  const isEditMode = computed(() => {
    return isNewCase.value || caseNotSubmitted.value;
  });

  const isMatrixOrderValid = computed(() => {
    return (
      !!productMatrixStore.activeMatrixOrder &&
      productMatrixStore.activeMatrixOrder.total > 0 &&
      !!productMatrixStore.activeMatrixOrder.date
    );
  });

  return { isNewCase, isEditMode, isReturn, isWarranty, caseNotSubmitted, isMatrixOrderValid };
}
